import {makeAutoObservable} from 'mobx';
import {MeetingsStore} from 'app/store/Meetings/MeetingsStore';

export class RootStore {
  meetings: MeetingsStore;

  constructor() {
    makeAutoObservable(this);
    this.meetings = new MeetingsStore(this);
  }
}
